export default "__VITE_ASSET__DmE_f7Pe__"